import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { string, number } from 'prop-types';
import { BrowseAndSearch } from './BrowseAndSearch';
import { ONLINE_STORE_ID } from '../../constants';

export const BrowseAndSearchContainer = (props) => {

  const { pageType, searchTimeout } = props;
  const isSearch = pageType === 'search';
  const disableSSR = typeof window !== 'undefined' && window.DISABLE_SSR;
  const varnish = !disableSSR && !isSearch;
  const store = useStore({ varnish, online: false });
  const { storeId, storeZip, isLocalized, membershipInformation } = store;

  const isMounted = ({ mounted }) => {
    if (storeId === ONLINE_STORE_ID && mounted) {
      return false;
    }

    if (membershipInformation?.error) {
      return mounted;
    }

    if (membershipInformation?.loading) {
      return false;
    }

    return mounted;
  };

  const searchOptsFn = ({ options, queryName }) => {
    if (queryName === 'searchStreamProduct') {
      const variables = options.variables;
      // eslint-disable-next-line no-param-reassign
      options.variables = undefined;
    }

    if (queryName === 'searchModel') {
      let to = 3000;
      if (searchTimeout) {
        if (typeof searchTimeout === 'string') {
          to = parseInt(searchTimeout, 10);
          // eslint-disable-next-line no-restricted-globals
          if (isNaN(to)) {
            to = 3000;
          }
        } else if (typeof searchTimeout === 'number') {
          to = searchTimeout;
        }
      }

      // eslint-disable-next-line no-param-reassign
      options.context = {
        ...(options.context || {}),
        timeout: to
      };
    }

    return options;
  };

  const browseDefaultVariables = {
    skipInstallServices: false,
    skipSpecificationGroup: false,
    loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership,
  };

  if (pageType === 'browse') {
    return (
      <QueryProvider
        queryOptions={searchOptsFn}
        defaultVariables={browseDefaultVariables}
        mounted={isMounted}
        cacheKey="browse-search"
      >
        {/* eslint-disable-next-line */}
        <BrowseAndSearch 
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          isLocalized={isLocalized}
          storeId={storeId}
          storeZip={storeZip}
        />
      </QueryProvider>
    );
  }

  return (
    <QueryProvider
      queryOptions={searchOptsFn}
      defaultVariables={browseDefaultVariables}
      mounted={isMounted}
      cacheKey="browse-search"
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <BrowseAndSearch {...props} isLocalized={isLocalized} storeId={storeId} storeZip={storeZip} />
    </QueryProvider>
  );

};

BrowseAndSearchContainer.propTypes = {
  pageType: string.isRequired,
  searchTimeout: string,
  productPodHoverDelay: number
};

BrowseAndSearchContainer.defaultProps = {
  searchTimeout: null,
  productPodHoverDelay: 500
};
